import type { CustomerCalendar } from '@/types/generated'

const CALENDAR_SWATCH_CLASSES = [
  'bg-violet-600',
  'bg-sky-600',
  'bg-emerald-600',
  'bg-amber-500',
  'bg-rose-500',
  'bg-indigo-600'
] as const

export function calendarSwatchClass(index: number): string {
  return CALENDAR_SWATCH_CLASSES[index % CALENDAR_SWATCH_CLASSES.length]
}

/** Prefer org-facing name, then provider calendar name. */
export function calendarDisplayLabel(cal: CustomerCalendar): string {
  const name = cal.name?.trim()
  if (name) {
    return name
  }
  return cal.calendar_name?.trim() || '—'
}

export function isCalendarVisibleInSidebar(cal: CustomerCalendar): boolean {
  return !cal.deactivated && !cal.calendar_deleted && !cal.calendar_readonly
}
